/* ==========================================================================
   Añadir al carrito desde la product card sin recargar la página.
   Si falla el AJAX se deja que el formulario haga el POST normal.
   ========================================================================== */

(function () {
  'use strict';

  function onSubmit(event) {
    var form = event.target;
    if (!form.matches('[data-card-form]')) return;

    event.preventDefault();

    var button = form.querySelector('.gyaa-card__add, .gyaa-hero__add');
    if (button) button.classList.add('is-loading');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        if (window.GYAA) window.GYAA.refreshCartCount();
        if (window.GYAA && window.GYAA.vueloAlCarrito) window.GYAA.vueloAlCarrito(button);
        if (window.GYAA && button) {
          /* El texto viene traducido desde Liquid: anunciar el aria-label del boton
             diria "AGREGAR AL CARRITO - Producto", que suena a orden, no a que ya
             se hizo. */
          window.GYAA.announce(button.getAttribute('data-added-label') || '');
        }
        if (button) {
          button.classList.add('is-added');
          /* Aqui habia un button.blur(). Se quito: tiraba el foco al <body>, asi
             que quien navega con teclado perdia el sitio en una rejilla de cientos
             de productos. Lo ponia para que no se quedara el aro pegado tras el
             click, pero el tema solo usa :focus-visible (base.css), que por
             definicion no pinta el aro en un click de raton. */
          setTimeout(function () { button.classList.remove('is-added'); }, 500);
        }
      })
      .catch(function () {
        if (window.GYAA && button) {
          window.GYAA.announce(button.getAttribute('data-error-label') || '');
        }
        form.submit();
      })
      .then(function () {
        if (button) button.classList.remove('is-loading');
      });
  }

  document.addEventListener('submit', onSubmit);
})();
